import { Field, useFormikContext } from "formik";
import { styled } from "@mui/material";
import RadioGroup from "../components/radio-group/RadioGroup";

const FormRadioGroupInputUnstyled = ({
  className,
  classNames = {}, // { viewText, group, label }
  direction = "row",
  labelPlacement = "end",
  id,
  name,
  onChange,
  options = [],
  ...props
}) => {
  const { setFieldValue, setFieldTouched } = useFormikContext();

  const handleChange = (e) => {
    if (typeof onChange === "function") {
      onChange(e);
      return;
    }
    const value = e.target.value;
    if (value === "true") {
      setFieldValue(name, true).then(() => {
        setFieldTouched(name, true);
      });
    } else if (value === "false") {
      setFieldValue(name, false).then(() => {
        setFieldTouched(name, true);
      });
    } else {
      setFieldValue(name, value).then(() => {
        setFieldTouched(name, true);
      });
    }
  };
  return (
    <Field
      name={name}
      as={RadioGroup}
      direction={direction}
      labelPlacement={labelPlacement}
      options={options}
      className={className}
      classNames={classNames}
      onChange={handleChange}
      // {...(typeof onChange === "function" ? { onChange } : {})}
      {...props}
    />
  );
};

const FormRadioGroupInput = styled(FormRadioGroupInputUnstyled)({});

export default FormRadioGroupInput;
